import Swal from 'sweetalert2';

// Function to show loading popup
const showLoadingPopup = (message = 'Loading...') => {
    Swal.fire({
        title: message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });
};

// Function to close popup
const closeLoadingPopup = () => {
    Swal.close();
};

export {
    showLoadingPopup,
    closeLoadingPopup,
};
